import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const Wrapper = styled.div`
  // width: ${() => `${viewSizeCalculator(11.25)}`}; // 11.25rem
  height: ${() => `${viewSizeCalculator(4)}`}; // 4rem
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  background-color: #ffffff;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 0.0625rem 0.3125rem #3333331a;
  position: relative;
  padding: ${() =>
    `${viewSizeCalculator(0.625)} ${viewSizeCalculator(
      0.75,
    )} ${viewSizeCalculator(0.625)} ${viewSizeCalculator(1.5)}`};
  box-sizing: border-box;
  ${({ $isSelected }) =>
    $isSelected &&
    `
    outline: ${viewSizeCalculator(1.5, true)} solid #E35B42;
  `}

  &:hover {
    cursor: pointer;
    outline: ${viewSizeCalculator(1.5, true)} solid #E35B42;
  }

  /* transition: all 0.3s ease-in-out; */
`;

export const ContentWrppper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.5)}`}; // 0.5rem
`;

export const Title = styled.h3`
  font-size: ${() => `${viewSizeCalculator(0.813)}`}; // 0.813rem
  font-weight: 400;
`;

export const SubTitle = styled.h3`
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  font-weight: 700;
  color: ${({ color }) => color || "#000000"};
`;

export const MoreOptionWrapper = styled.div`
  cursor: pointer;
  opacity: 30%;
  opacity: ${({ isOpen }) => (isOpen ? "1" : "0.3")}; /* Highlight when open */
  transition: all 0.3s ease-in-out;
  width: ${() => `${viewSizeCalculator(2.5)}`}; // 2.5rem
  height: ${() => `${viewSizeCalculator(2.5)}`}; // 2.5rem

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${() => `${viewSizeCalculator(0.938)}`}; // 0.938rem

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`}; // 1.5rem
    height: ${() => `${viewSizeCalculator(1.5)}`}; // 1.5rem
    fill: ${({ isOpen }) => (isOpen ? "black" : "currentColor")};
    transition: fill 0.3s ease; /* Optional smooth transition */
  }

  &:hover {
    background-color: #f5f5f5;
    opacity: 1;
  }
`;
